import React from "react";
import { Link } from "react-router-dom";

function highlightWarnings(text = "") {
  if (!text) return text;
  return text.replace(
    /\(do not (eat|touch|touch or eat)\)/gi,
    (match) => `<span class="danger-info-warning-text">${match}</span>`
  );
}

function getRiskClassName(riskLevel = "") {
  if (/extreme/i.test(riskLevel)) return "danger-info-risk danger-info-risk--extreme";
  if (/high/i.test(riskLevel)) return "danger-info-risk danger-info-risk--high";
  if (/medium/i.test(riskLevel)) return "danger-info-risk danger-info-risk--medium";
  return "danger-info-risk danger-info-risk--low";
}

export default function DangerInfoSummarySection({ data, showEmptyState, t }) {
  const hasNoDangers = [
    "fish",
    "wildlife",
    "env",
    "war",
    "disease",
  ].every(
    (category) =>
      !Array.isArray(data[category]) || data[category].length === 0
  );

  return (
    <>
      <h3>⚠️ {t("danger_title")}</h3>

      {showEmptyState && hasNoDangers && (
        <p className="danger-info-empty-state">
          {t("danger_empty_location")}
        </p>
      )}

      {/* ------------------------------------------------------ */}
      {/* 1) Venomous / Poisonous Fish — ONLY SHOW IF NOT EMPTY */}
      {/* ------------------------------------------------------ */}
      {data.fish.length > 0 && (
        <section style={{ marginTop: 12 }}>
          <h4>🐡 {t("danger_fish")}</h4>

          <ul style={{ paddingLeft: 20 }}>
            {data.fish.map((f, i) => {
              const fishId = f.name
                .toLowerCase()
                .replace(/\s*\(.*?\)\s*/g, "")
                .trim()
                .replace(/\s+/g, "-");

              return (
                <li key={i}>
                  <Link
                    to={`/fishipedia#${fishId}`}
                    className="fishipedia-link"
                    title={t("danger_view_fishipedia", { name: f.name })}
                    style={{
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    {f.name}
                  </Link>{" "}
                  —{" "}
                  <span
                    dangerouslySetInnerHTML={{ __html: highlightWarnings(f.risk) }}
                  />

                  {f.edible === false &&
                    !/\(do not (eat|touch|touch or eat)\)/i.test(f.risk) && (
                      <span className="danger-info-warning-text">
                        {" "}
                        ({t("danger_do_not_eat")})
                      </span>
                    )}

                  {f.risk_level && (
                    <span
                      className={getRiskClassName(f.risk_level)}
                    >
                      [{f.risk_level}]
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
        </section>
      )}
    </>
  );
}
